import { render, staticRenderFns } from "./DescriptionFields.vue?vue&type=template&id=78c3ae5c&lang=pug"
import script from "./DescriptionFields.vue?vue&type=script&lang=ts"
export * from "./DescriptionFields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports